import * as React from 'react';
import { memo } from 'react';

import ContentLoader from 'react-content-loader';
import { useWindowSize } from 'services/hooks';
import { CLIENT_WIDTH } from 'services/ui';

export const FilterPreloader = memo((props) => {
  const { width } = useWindowSize();
  return width && width >= CLIENT_WIDTH.DESKTOP ? (
    <ContentLoader
      speed={2}
      width={460}
      height={76}
      viewBox="0 0 460 76"
      backgroundColor="var(--color-bg-gray)"
      foregroundColor="var(--color-additional-gray)"
      {...props}>
      <rect width="280" height="44" fill="var(--color-bg-gray)" />
      <rect y="52" width="460" height="24" fill="var(--color-bg-gray)" />
    </ContentLoader>
  ) : width && width >= CLIENT_WIDTH.TABLET ? (
    <ContentLoader
      speed={2}
      width={348}
      height={56}
      viewBox="0 0 348 56"
      backgroundColor="var(--color-bg-gray)"
      foregroundColor="var(--color-additional-gray)"
      {...props}>
      <rect width="206" height="36" fill="var(--color-bg-gray)" />
      <rect y="40" width="348" height="16" fill="var(--color-bg-gray)" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={2}
      width={296}
      height={44}
      viewBox="0 0 296 44"
      backgroundColor="var(--color-bg-gray)"
      foregroundColor="var(--color-additional-gray)"
      {...props}>
      <rect width="206" height="24" fill="var(--color-bg-gray)" />
      <rect y="26" width="296" height="16" fill="var(--color-bg-gray)" />
    </ContentLoader>
  );
});
